import {draftsLocalForageAPI, removeItemFromStorage, saveItemToStorage} from './storage';

export async function saveDraft(key: string, value: any) {
    return saveItemToStorage(draftsLocalForageAPI, key, value);
}

export async function removeDraft(key: string) {
    return removeItemFromStorage(draftsLocalForageAPI, key);
}
